var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01587 4.25H6C5.58579 4.25 5.25 4.58579 5.25 5C5.25 5.05087 5.25506 5.10055 5.26472 5.14858L5.25003 6.88365C5.24652 7.29785 5.57945 7.63647 5.99365 7.63997C6.40785 7.64348 6.74647 7.31055 6.74997 6.89635L6.75968 5.75H11.1563L11.1411 17.938H10C9.58579 17.938 9.25 18.2738 9.25 18.688C9.25 19.1022 9.58579 19.438 10 19.438H14C14.4142 19.438 14.75 19.1022 14.75 18.688C14.75 18.2738 14.4142 17.938 14 17.938H12.6411L12.6563 5.75H17.2596L17.25 6.88365C17.2465 7.29785 17.5795 7.63647 17.9937 7.63997C18.4079 7.64348 18.7465 7.31055 18.75 6.89635L18.766 5.00635C18.7695 4.59215 18.4365 4.25353 18.0224 4.25003C18.0176 4.24999 18.0128 4.24999 18.0081 4.25004C18.0054 4.25001 18.0027 4.25 18 4.25H6.01587Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.866b4cbb988b33389917e024bfce605c.svg";
export { ForwardRef as ReactComponent };